/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GeneratorExternalKey
 */
export interface GeneratorExternalKey {
    /**
     * 
     * @type {string}
     * @memberof GeneratorExternalKey
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof GeneratorExternalKey
     */
    dataProviderKey: string;
}

/**
 * Check if a given object implements the GeneratorExternalKey interface.
 */
export function instanceOfGeneratorExternalKey(value: object): value is GeneratorExternalKey {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('dataProviderKey' in value) || value['dataProviderKey'] === undefined) return false;
    return true;
}

export function GeneratorExternalKeyFromJSON(json: any): GeneratorExternalKey {
    return GeneratorExternalKeyFromJSONTyped(json, false);
}

export function GeneratorExternalKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeneratorExternalKey {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'dataProviderKey': json['dataProviderKey'],
    };
}

export function GeneratorExternalKeyToJSON(json: any): GeneratorExternalKey {
    return GeneratorExternalKeyToJSONTyped(json, false);
}

export function GeneratorExternalKeyToJSONTyped(value?: GeneratorExternalKey | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'dataProviderKey': value['dataProviderKey'],
    };
}

